/* Вход раздела «Проекты» («Озвучка проектов») из «Студии» и «Текста» без разметки: нормализация входа и передача разделу. */
import { toolPrice } from '../studio/circle/tool-helpers';

/** Вход «Озвучки проектов» из «Студии» и «Текста» (APP-SPEC-5 §5 «Входы»): text — строки «Имя: реплика» или абзацы;
    speakers — собеседники по порядку (имена или {name, voice}), они становятся ролями; name — название нового проекта (по умолчанию «Расшифровка»);
    price — цена инструмента из сервера (ToolPrice): единица per_100_chars даёт подзаголовок шапки «3 C за 100 знаков» */
export interface ProjectsEntry {
  text: string;
  speakers?: Array<string | { name: string; voice?: number | null }>;
  name?: string;
  price?: unknown;
}
const SPEAKERS_MAX = 20;
/** Вход без мусора: собеседники — непустые имена до 64 знаков, не больше 20; название — до 120 знаков */
export function projectsEntry(value: string | ProjectsEntry): ProjectsEntry {
  if (typeof value === 'string') return { text: value };
  const text = typeof value?.text === 'string' ? value.text : '';
  const speakers = Array.isArray(value?.speakers)
    ? value.speakers
        .map(item => {
          if (typeof item === 'string') return item.trim().slice(0, 64);
          if (item && typeof item === 'object' && typeof item.name === 'string') {
            const name = item.name.trim().slice(0, 64);
            const voice = Number(item.voice);
            return name ? (Number.isSafeInteger(voice) && voice > 0 ? { name, voice } : name) : '';
          }
          return '';
        })
        .filter(item => (typeof item === 'string' ? !!item : !!item.name))
        .slice(0, SPEAKERS_MAX)
    : [];
  const name = typeof value?.name === 'string' ? value.name.trim().slice(0, 120) : '';
  return { text, ...(speakers.length ? { speakers } : {}), ...(name ? { name } : {}), ...(value?.price !== undefined ? { price: value.price } : {}) };
}
/** Сценарий из «Студии» или «Текста»: забирается разделом один раз */
let handoff: ProjectsEntry | null = null;
export function stageProjects(value: string | ProjectsEntry) {
  handoff = projectsEntry(value);
}
export function takeProjects() {
  const value = handoff;
  handoff = null;
  return value;
}
/** Цена за 100 знаков из ToolPrice; другая единица или нет числа — 0 */
export function unitPer100(price: unknown) {
  const value = toolPrice(price);
  return value.unit === 'per_100_chars' && value.amount !== null && value.amount > 0 ? value.amount : 0;
}
/** Цена за 100 знаков строки «Озвучка проектов» каталога «Все инструменты» (GET /app/studio/tools, §6.7: вход entry.screen = script или
    action.entry.screen, price.unit = per_100_chars) — подзаголовок шапки при входе в раздел без цены входа; нет такой строки — 0 */
export function scriptToolUnit(items: ReadonlyArray<Record<string, unknown>>) {
  const screen = (entry: unknown) => (entry && typeof entry === 'object' ? (entry as { screen?: unknown }).screen : undefined);
  const row = items.find(item => screen(item.entry) === 'script' || screen((item.action as { entry?: unknown } | undefined)?.entry) === 'script');
  return row ? unitPer100(row.price) : 0;
}
